exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ComponentGalleryWrapper {\n  padding: 10px;\n  position: absolute;\n  top: 9px;\n  right: 5px;\n  width: 510px;\n  height: 653px; }\n\n.ItemRow {\n  width: 500px;\n  margin-top: 6px; }\n\n.Item {\n  box-sizing: border-box;\n  display: inline-block;\n  border: 1px solid black;\n  width: 240px;\n  height: 240px; }\n  .Item .backgroundImage {\n    width: 100%;\n    height: 100%; }\n\n.Item:not(:first-child) {\n  margin-left: 8px; }\n", ""]);

// exports
